export default {
  title: {
    id: 'bo_sellers-listing-search-product-no-result-title',
    defaultMessage: 'No results found',
  },
  subtitle: {
    id: 'bo_sellers-listing-search-product-no-result-subtitle',
    defaultMessage:
      'You’re ahead of the game. Want to add this new item to the Back Market catalog?',
  },
  addNewButtonLabel: {
    id: 'bo_sellers-listing-search-product-no-result-action-add-new',
    defaultMessage: 'Add new item to catalog',
  },
}
